<template>
  <div id="page-company-address-edit">
    <user-addresses
        v-if="model"
        ref="form"
        v-model="model"
        :loading="loading"
        title="Create Address"
        subtitle=" "
    />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
            @click="$router.push({ name: 'contact.addresses.list'})"
            class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
            @click="save"
            class="my-4"
            color="light"
          >
            Create
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import CardPage from '../../../components/Views/CardPage';
import UserAddresses from '../forms/UserAddresses';
import SaveModelMixin from '../../../../components/mixins/SaveModelMixin';
import NotificationMixin from '../../../../components/mixins/NotificationMixin';

export default {
  components: {
    CardPage,
    UserAddresses,
  },
  mixins: [SaveModelMixin, NotificationMixin],
  data () {
    return {
      loading: false,
      model: {},
    }
  },
  methods: {
    getParams() {
      const references = ['AddressType_FK'];
      const params = this.getModelCopy(true);

      // We hard code this to 0.
      // On the API we then set it to 1 if this is the only address for this Company
      params.IsPrimaryAddress = 0;
      params.Contact_FK = this.$route.params.id;

      this.setReferences(references);

      return params;
    },
    validate() {
      return this.$refs.form.validate();
    },
    async save() {
      if (!this.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = this.getParams();

      try {
        const {data} = await this.$api.users.createAddress(this.$route.params.id, params);
        this.notifySuccess('Address created');
        this.$router.back();
      } catch (e) {
        this.notifyError('Address failed to be created');
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>
